import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { showToastMessage } from 'enable-ui';

import AdminUSerRoutes from 'modules/admin-user/Router';
import AnalyticsRouters from 'modules/analytics/Router';
import { useAuthStore, userProfileSelector } from 'modules/auth/core';
import { CalendarPage } from 'modules/calendar/pages';
import { ChangePasswordPage } from 'modules/change-password/page';
import ClassesRoutes from 'modules/classes/Router';
import DashboardRoutes from 'modules/dashboard/Routers';
import InstitutionInfoRoutes from 'modules/institution-info/Routers';
import InstitutionsRoutes from 'modules/institutions/Routers';
import { MasterLayout } from 'modules/layout/MasterLayout';
import { onLogout } from 'modules/layout/core/constrollers/master-layout';
import LearnerRoutes from 'modules/learners/Routers';
import PermissionsRouters from 'modules/permissions/Routers';
import TrainerRoutes from 'modules/trainers/Routers';

import { getPathDefault } from 'helpers';
import { includes, isEmpty } from 'lodash';

import { ERROR_MESSAGE } from 'constants/message';
import { ListAuthPath, PATH } from 'constants/path';

import { ProfileRoutes } from './ProfileRoutes';

const PrivateRoutes = () => {
  const userProfile = useAuthStore(userProfileSelector);

  const navigateTo = useNavigate();

  if (!userProfile?.id) return null;

  if (isEmpty(userProfile.permission.webs)) {
    showToastMessage('error', ERROR_MESSAGE.NONE_PERMISSION);
    onLogout();
    navigateTo(PATH.LOGIN);
  }

  const isAuthPath = includes(ListAuthPath, location.pathname);

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path={`${PATH.CONTENT}/*`} element={<DashboardRoutes />} />
        <Route path={`${PATH.INSTITUTIONS}/*`} element={<InstitutionsRoutes />} />
        <Route path={`${PATH.TRAINERS}/*`} element={<TrainerRoutes />} />
        <Route path={`${PATH.LEARNERS}/*`} element={<LearnerRoutes />} />
        <Route path={`${PATH.CLASSES}/*`} element={<ClassesRoutes />} />
        <Route path={`${PATH.ADMINS}/*`} element={<AdminUSerRoutes />} />
        <Route path={`${PATH.ANALYTICS}/*`} element={<AnalyticsRouters />} />
        <Route path={`${PATH.INSTITUTION_INFO}/*`} element={<InstitutionInfoRoutes />} />
        <Route path={`${PATH.PERMISSIONS}/*`} element={<PermissionsRouters />} />
        <Route path={PATH.CALENDAR} element={<CalendarPage />} />
        <Route path={PATH.USER} element={<div>User</div>} />
        <Route
          index
          path="/"
          element={<Navigate to={getPathDefault(userProfile.permission.webs[0])} />}
        />
        <Route path={`${PATH.CHANGE_PASSWORD}/*`} element={<ChangePasswordPage />} />
        <Route path={`${PATH.PROFILE}/*`} element={<ProfileRoutes />}></Route>
        <Route
          path="*"
          element={<Navigate to={getPathDefault(userProfile.permission.webs[0])} />}
        />
      </Route>
    </Routes>
  );
};

export { PrivateRoutes };
